// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectableListItem__container-b18e0c {
  --color: var(--base-110);
  --icon-color: var(--base-80);
  --selectable-list-item-background-color: var(--addition-70);
  --selectable-list-item-hover-background-color: var(--brand-primary-40_10);
  --selectable-list-item-border: 1px solid var(--base-120_08);
  min-height: var(--selectable-list-item-min-height);
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: var(--selectable-list-item-padding-top);
  padding-bottom: var(--selectable-list-item-padding-bottom);
  padding-inline-start: var(--selectable-list-item-padding-inline-start);
  padding-inline-end: var(--selectable-list-item-padding-inline-end);
  cursor: pointer;
  color: var(--color);
  border: var(--selectable-list-item-border);
  background-color: var(--selectable-list-item-background-color);
  border-radius: 16px;
  text-align: start;
}

.SelectableListItem__container-b18e0c:disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: default;
}

.SelectableListItem__container-b18e0c:hover {
  background-color: var(--selectable-list-item-hover-background-color);
}

.SelectableListItem__selected-f3f2e9 {
  --selectable-list-item-border: 1px solid var(--brand-primary-40);
  background-color: var(--brand-primary-40_10);
}

.SelectableListItem__content-f7dfa5 {
  display: flex;
  flex: 1;
  align-items: center;
  overflow: hidden;
  gap: 16px;
}

.SelectableListItem__icon-dc7c2c {
  text-align: center;
  display: flex;
  align-items: center;
  color: var(--icon-color);
}

.SelectableListItem__icon-dc7c2c svg {
  fill: currentColor;
}

.SelectableListItem__content-text-b18c32 {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
}

.SelectableListItem__title-f5eb14 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
}

.SelectableListItem__secondary-title-add0be {
  font: var(--selectable-list-item-secondary-title-font);
  letter-spacing: var(--selectable-list-item-secondary-title-font-spacing);
  color: var(--base-80);
}

.SelectableListItem__size-small-1-bcfffb,
.SelectableListItem__size-medium-1-bb90d4 {
  --selectable-list-item-secondary-title-font: var(--font-subtitle-4);
  --selectable-list-item-secondary-title-font-spacing: var(--font-spacing-subtitle-4);
}

.SelectableListItem__size-small-2-bdd201,
.SelectableListItem__size-medium-2-ec1428 {
  --selectable-list-item-secondary-title-font: var(--font-body-4);
  --selectable-list-item-secondary-title-font-spacing: var(--font-spacing-body-4);
}

.SelectableListItem__size-small-1-bcfffb,
.SelectableListItem__size-small-2-bdd201 {
  --selectable-list-item-min-height: 72px;
  --selectable-list-item-padding-top: 8px;
  --selectable-list-item-padding-bottom: 8px;
  --selectable-list-item-padding-inline-start: 12px;
  --selectable-list-item-padding-inline-end: 12px;
}

.SelectableListItem__size-medium-1-bb90d4,
.SelectableListItem__size-medium-2-ec1428 {
  --selectable-list-item-min-height: 104px;
  --selectable-list-item-padding-top: 16px;
  --selectable-list-item-padding-bottom: 16px;
  --selectable-list-item-padding-inline-start: 16px;
  --selectable-list-item-padding-inline-end: 24px;
}

.SelectableListItem__suffix-cdc7d1 {
  color: var(--base-70);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/SelectableListItem/SelectableListItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,4BAAA;EACA,2DAAA;EACA,yEAAA;EAEA,2DAAA;EAEA,kDAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oDAAA;EACA,0DAAA;EACA,sEAAA;EACA,kEAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,8DAAA;EACA,mBAAA;EACA,iBAAA;AADF;;AAIA;EACE,oBAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,oEAAA;AADF;;AAIA;EACE,gEAAA;EACA,4CAAA;AADF;;AAIA;EACE,aAAA;EACA,OAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AADF;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,OAAA;EACA,sBAAA;EACA,uBAAA;AADF;;AAIA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AADF;;AAIA;EACE,sDAAA;EACA,wEAAA;EACA,qBAAA;AADF;;AAIA;;EAEE,mEAAA;EACA,mFAAA;AADF;;AAIA;;EAEE,+DAAA;EACA,+EAAA;AADF;;AAIA;;EAEE,uCAAA;EACA,uCAAA;EACA,0CAAA;EACA,iDAAA;EACA,+CAAA;AADF;;AAIA;;EAEE,wCAAA;EACA,wCAAA;EACA,2CAAA;EACA,iDAAA;EACA,+CAAA;AADF;;AAIA;EACE,qBAAA;AADF","sourcesContent":[".container {\n  --color: var(--base-110);\n  --icon-color: var(--base-80);\n  --selectable-list-item-background-color: var(--addition-70);\n  --selectable-list-item-hover-background-color: var(--brand-primary-40_10);\n\n  --selectable-list-item-border: 1px solid var(--base-120_08);\n\n  min-height: var(--selectable-list-item-min-height);\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-top: var(--selectable-list-item-padding-top);\n  padding-bottom: var(--selectable-list-item-padding-bottom);\n  padding-inline-start: var(--selectable-list-item-padding-inline-start);\n  padding-inline-end: var(--selectable-list-item-padding-inline-end);\n  cursor: pointer;\n  color: var(--color);\n  border: var(--selectable-list-item-border);\n  background-color: var(--selectable-list-item-background-color);\n  border-radius: 16px;\n  text-align: start;\n}\n\n.container:disabled {\n  pointer-events: none;\n  opacity: 0.5;\n  cursor: default;\n}\n\n.container:hover {\n  background-color: var(--selectable-list-item-hover-background-color);\n}\n\n.selected {\n  --selectable-list-item-border: 1px solid var(--brand-primary-40);\n  background-color: var(--brand-primary-40_10);\n}\n\n.content {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  overflow: hidden;\n  gap: 16px;\n}\n\n.icon {\n  text-align: center;\n  display: flex;\n  align-items: center;\n  color: var(--icon-color);\n}\n\n.icon svg {\n  fill: currentColor;\n}\n\n.content-text {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n}\n\n.secondary-title {\n  font: var(--selectable-list-item-secondary-title-font);\n  letter-spacing: var(--selectable-list-item-secondary-title-font-spacing);\n  color: var(--base-80);\n}\n\n.size-small-1,\n.size-medium-1 {\n  --selectable-list-item-secondary-title-font: var(--font-subtitle-4);\n  --selectable-list-item-secondary-title-font-spacing: var(--font-spacing-subtitle-4);\n}\n\n.size-small-2,\n.size-medium-2 {\n  --selectable-list-item-secondary-title-font: var(--font-body-4);\n  --selectable-list-item-secondary-title-font-spacing: var(--font-spacing-body-4);\n}\n\n.size-small-1,\n.size-small-2 {\n  --selectable-list-item-min-height: 72px;\n  --selectable-list-item-padding-top: 8px;\n  --selectable-list-item-padding-bottom: 8px;\n  --selectable-list-item-padding-inline-start: 12px;\n  --selectable-list-item-padding-inline-end: 12px;\n}\n\n.size-medium-1,\n.size-medium-2 {\n  --selectable-list-item-min-height: 104px;\n  --selectable-list-item-padding-top: 16px;\n  --selectable-list-item-padding-bottom: 16px;\n  --selectable-list-item-padding-inline-start: 16px;\n  --selectable-list-item-padding-inline-end: 24px;\n}\n\n.suffix {\n  color: var(--base-70);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SelectableListItem__container-b18e0c`,
	"selected": `SelectableListItem__selected-f3f2e9`,
	"content": `SelectableListItem__content-f7dfa5`,
	"icon": `SelectableListItem__icon-dc7c2c`,
	"content-text": `SelectableListItem__content-text-b18c32`,
	"contentText": `SelectableListItem__content-text-b18c32`,
	"title": `SelectableListItem__title-f5eb14`,
	"secondary-title": `SelectableListItem__secondary-title-add0be`,
	"secondaryTitle": `SelectableListItem__secondary-title-add0be`,
	"size-small-1": `SelectableListItem__size-small-1-bcfffb`,
	"sizeSmall1": `SelectableListItem__size-small-1-bcfffb`,
	"size-medium-1": `SelectableListItem__size-medium-1-bb90d4`,
	"sizeMedium1": `SelectableListItem__size-medium-1-bb90d4`,
	"size-small-2": `SelectableListItem__size-small-2-bdd201`,
	"sizeSmall2": `SelectableListItem__size-small-2-bdd201`,
	"size-medium-2": `SelectableListItem__size-medium-2-ec1428`,
	"sizeMedium2": `SelectableListItem__size-medium-2-ec1428`,
	"suffix": `SelectableListItem__suffix-cdc7d1`
};
module.exports = ___CSS_LOADER_EXPORT___;
